(function() {
    "use strict";
    eclipseApp.directive('ngRepeatEnd', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if (scope.$last) {
                    scope.$eval(attrs.ngRepeatEnd);
                }
            }
        };
    });
})();
